// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tvp-player{height:100%;width:100%;position:relative}
`, "",{"version":3,"sources":["webpack://./sass/_embed.scss"],"names":[],"mappings":"AACA,YACI,WAAY,CACZ,UAAW,CACX,iBAAkB","sourcesContent":["@import \"variables.json\";\n.tvp-player {\n    height: 100%;\n    width: 100%;\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
